import 'css-chunksrc/client/scenes/secondaryCriteriaTemplate/criteria/form/textForm/styles.scss';export default {
  "form": "_form_1ron9_1",
  "attribute": "_attribute_1ron9_9"
};